<script lang="ts" setup>
import { useAudioPlayer } from './logic'

const speed = ref(1)
const cycles = [1, 1.2, 2]

const audio = useAudioPlayer()

function toggleSpeed() {
  let index = cycles.indexOf(speed.value) + 1

  if (index >= cycles.length)
    index = 0

  audio.updatePlaybackRate(
    speed.value = cycles[index]
  )
}
</script>

<template>
  <IconButton title="Adjust speed" variant="secondary" class="!w-max p-2" @click="toggleSpeed">
    <div class="w-40px text-center text-sm font-medium">
      {{ speed }}x
    </div>
  </IconButton>
</template>

<style scoped lang="sass">
input[type="range"]
  @apply p-0 m-0 h-max w-full appearance-none bg-transparent cursor-pointer outline-none border-none

  &::-webkit-slider-runnable-track
    @apply h-4px bg-$color-neutral-border rounded-full

  &::-webkit-slider-thumb
    @apply relative top-2/4 appearance-none bg-$color-neutral h-3 w-3 rounded-full
    transform: translateY(-50%)

  &:focus::-webkit-slider-thumb
    @apply bg-$color-primary outline-2 outline-solid outline-$color-neutral-border outline-offset-2

  // Firefox
  &::-moz-range-track
    @apply h-4px bg-$color-neutral-border rounded-full

  &::-moz-range-thumb
    @apply relative top-2/4 appearance-none bg-$color-neutral h-3 w-3 rounded-full
    transform: translateY(-50%)

  &:focus::-moz-range-thumb
    @apply bg-$color-primary outline-2 outline-solid outline-$color-neutral-border outline-offset-2
</style>
